import Logger from './Logger';

type ApiErrorResponse = {
  errors?: string[];
  code?: string;
};

type FormatErrorMessageParams = {
  defaultErrorMessage: string;
  errorMessageMap: Record<string, string>;
  error?: ApiErrorResponse | string;
  errorCodeMap?: Record<string, string>;
  errorMessage?: string;
} & ({
  errorMessage?: never;
  error: ApiErrorResponse | string;
  errorCodeMap: Record<string, string>;
} | {
  error?: never;
  errorMessage: string;
});

export const formatErrorMessage = (params: FormatErrorMessageParams) => {
  const { defaultErrorMessage, errorMessage, errorMessageMap, errorCodeMap, error } = params;

  if (typeof error === 'object' && error?.code && errorCodeMap) {
    const formattedErrorMessage = errorCodeMap[error.code];

    if (formattedErrorMessage) {
      return formattedErrorMessage;
    }

    // We didn't find a matching error code, so we'll try to format based on the error message
  }

  const errorMessageFromError = typeof error === 'string'
    ? error
    : error?.errors?.[0];

  const errorMessageToFormat = errorMessage || errorMessageFromError;

  if (!errorMessageToFormat) {
    Logger.error('No error message or code found to format', {
      error,
      errorMessage,
    });

    return defaultErrorMessage;
  }

  const formattedErrorMessage = Object.entries(errorMessageMap)
    .find(([key]) => errorMessageToFormat.includes(key))?.[1];

  if (!formattedErrorMessage) {
    Logger.error('Unknown error', {
      error,
      errorMessage,
    });

    return defaultErrorMessage;
  }

  return formattedErrorMessage;
};
